import { render } from "./ratingstars.vue?vue&type=template&id=22db335d"
import script from "./ratingstars.vue?vue&type=script&lang=js"
export * from "./ratingstars.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__